import { render, staticRenderFns } from "./Oops.vue?vue&type=template&id=a4aa321c&"
import script from "./Oops.vue?vue&type=script&lang=js&"
export * from "./Oops.vue?vue&type=script&lang=js&"
import style0 from "./Oops.vue?vue&type=style&index=0&id=a4aa321c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports